// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"R_TheComp___DP5v"};